import { render, staticRenderFns } from "./FinalEvaluationList.vue?vue&type=template&id=79205ee8&scoped=true&"
import script from "./FinalEvaluationList.vue?vue&type=script&lang=js&"
export * from "./FinalEvaluationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79205ee8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCardTitle})
